module.exports = __webpack_public_path__ + "static/media/mobile_nav_bottom_dog.439a62ba.svg";